<template>
  <div>
    <el-table
      :data="viewProductTableList"
      :header-cell-style="{color:'#000000',fontFamily:'Satoshi-Medium !important',fontSize:'14px'}"
      stripe
      border>
      <el-table-column
        width="300"
        label="Store Name"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.storeName" class="store-name" @click="openReport(scope.row)">{{scope.row.storeName}}</span>
          <span v-else class="store-name-na">N/A</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Viewed Product"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.productName" class="viewed-product" @click="openProduct(scope.row)">{{scope.row.productName}}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="Visit Time"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.time" class="visit-time">{{ handleTime(scope.row.time)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        label="Views"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.quantity" class="views">{{scope.row.quantity}}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :currentPage="query.pageNo"
      :total="total"
      :pageSize="query.pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></Pagination>
  </div>
</template>

<script>
import { getAction } from '../../../api/manage'
import Pagination from '../../components/pagination.vue'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      viewProductTableList: [],
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 20,
        marketingId: '',
        marketingBatch: ''
      }
    }
  },
  methods: {
    handleTime(time) {
      time = time.replaceAll('-', '/')
      let index = time.lastIndexOf(':')
      return time.substring(0, index)
    },
    openProduct(row) {
      let routeUrl = ''
      if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
        routeUrl = 'https://test-thalesmart-manage-ui2.hupofintech.com/product' + row.seoUrl
      } else {
        routeUrl = 'https://www.shopvidi.com/product' + row.seoUrl
      }
      window.open(routeUrl, '_blank')
    },
    openReport(row) {
      var encrypt = btoa(row.storeId)
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${row.userId}&storeId=${encrypt}`)
      window.open(routeUrl.href, '_blank')
    },
    init(marketingId, marketingBatch) {
      this.query.marketingId = marketingId
      this.query.marketingBatch = marketingBatch
      this.query.pageNo = 1
      this.query.pageSize = 20
      this.loadData()
    },
    loadData() {
      // 判断参数
      if (this.query.marketingId === undefined || !this.query.marketingId || this.query.marketingBatch === undefined || !this.query.marketingBatch) {
        this.$message.error('缺少参数')
        return
      }
      getAction('/marketing/activity/api/v0.2/view-product/detail/list', this.query).then(response => {
        if (response.success) {
          if (response.result) {
            this.viewProductTableList = response.result.records
            this.total = response.result.total
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNo = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.query.pageNo = currentPage
      this.loadData()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-table--border .el-table__cell{
  border-right:none
}
.store-name,.store-name-na,.viewed-product,.visit-time,.views{
  color: #000000;
}
.store-name,.viewed-product{
  cursor: pointer;
  text-decoration: underline;
}
.store-name,.viewed-product{
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}
</style>



// WEBPACK FOOTER //
// src/pages/store-based-marketing/store-based-marketing-detail/view-product.vue